import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { baseURL } from "../../components/BaseURL";

const Login = () => {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  function getCookie(name) {
    let cookies = document.cookie.split("; ");

    for (let cookie of cookies) {
      let [key, value] = cookie.split("=");

      if (key === name)
        // alert("value", value);
        return value;
    }

    return null;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    fetch(`${baseURL}/project-authentication/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        password,
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`); // Handles HTTP errors
        }
        return res.json(); // Return the parsed JSON data
      })
      .then((data) => {
        setLoading(false);

        if (true) {
          // localStorage.setItem("classified-ads-token", data.token);
          localStorage.setItem("access_token", data.access);

          // debugger;
          window.location.href = "/";

          Swal.fire({
            title: "Success!",
            text: "You have successfully logged in!",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
        } else if (data.error) {
          setError(data.error);
        } else {
          setError("Something went wrong! Please try again.");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Login failed:", error);
        setError("Login failed. Please try again.");
      });
  };

  const verifyToken = async () => {
    try {
      const accessToken = localStorage.getItem("access_token");
      // debugger;

      if (accessToken) {
        window.location.href = "/";
      } else {
        // dispatch(setTokenVerificationStatus("unverified"));
      }
    } catch (error) {
      console.error("Error verifying token:", error);
      // dispatch(setTokenVerificationStatus("unverified"));
    }
  };

  useEffect(() => {
    let accessToken = getCookie("access");
    let refreshToken = getCookie("refresh");
    // debugger;

    if (accessToken) {
      localStorage.setItem("access_token", accessToken);
    } else {
      localStorage.setItem("access_token", "");
    }
    if (refreshToken) {
      localStorage.setItem("refresh_token", refreshToken);
    } else {
      localStorage.setItem("refresh_token", "");
    }
    verifyToken();
    // const timerFn = setInterval(() => {
    //   // console.log("interval checking");
    //   verifyToken();
    // }, 4 * 60 * 1000);

    // return () => clearInterval(timerFn);
  }, []);

  return (
    <section className="text-gray-600 bg-[#0e0c23] body-font">
      <div className="container px-5 py-24 mx-auto flex justify-center items-center">
        <div className="w-11/12 lg:w-2/6 md:w-1/2 bg-[#272737] rounded-lg p-8 flex flex-col mt-10 md:mt-0">
          <h2 className="text-pink-500 text-lg font-medium title-font mb-5">
            Login
          </h2>
          <div className="text-red-500">{error && <li>{error}</li>}</div>
          <div className="relative mb-4">
            <label for="full-name" className="leading-7 text-sm text-white">
              Email
            </label>
            <input
              onChange={(e) => setEmail(e.target.value)}
              type="text"
              id="full-name"
              name="full-name"
              placeholder="Type your email"
              className="w-full bg-[#272737] rounded border border-pink-500 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-white py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>
          <div className="relative mb-4">
            <label for="password" className="leading-7 text-sm text-white">
              Password
            </label>
            <input
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              id="password"
              name="password"
              placeholder="Type password"
              className="w-full bg-[#272737] rounded border border-pink-500 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-white py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>
          {loading ? (
            <button className="main_btn rad8px">
              Loading...
            </button>
          ) : (
            <button
              onClick={handleSubmit}
              className="main_btn rad8px py-2 px-8 focus:outline-none"
            >
              Login
            </button>
          )}

          <p className="text-xs mt-3 text-white">
            Don't have an account?{" "}
            <Link to="/register" className="underline text-pink-500">
              Sign up
            </Link>{" "}
            here.
          </p>

          <p>
            <Link
              to="/forget-password"
              className="text-sm underline mt-2 text-pink-500"
            >
              Forgot password?
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Login;
